import actionType from "./actionTypes";
import initialState from "./initialState";


const  adminReducer = (state = initialState, action) => {
  switch (action.type) {

      
          case actionType.GET_MONTHLY_REQUEST_LIST_SUCCESS:
          return {
            ...state,
            getMonthlyRequestListDetails: action.payload,
            getMonthlyRequestStatus:true
           };
          case actionType.GET_MONTHLY_REQUEST_LIST_FAILURE:
          return {
              ...state,
              getMonthlyRequestStatus: false
          };
          case actionType.DELETE_UNPROCESSED_REQUEST_SUCCESS:
          return {
            ...state,
            deleteUnprocessedRequestStatus: true,
          };
          case actionType.DELETE_UNPROCESSED_REQUEST_FAILURE:
          return {
              ...state,
          deleteUnprocessedRequestStatus: false
          };
          case actionType.SAVE_PAYMENT_RULE:
          return{
            ...state,
            savedPaymentRule : action.payload,
            editPaymentRuleStatus: false
          }
          case actionType.EDIT_PAYMENT_RULE_SUCCESS:
          return {
            ...state,
            editPaymentRuleStatus: true,
            message: action.message
          };
          case actionType.EDIT_PAYMENT_RULE_FAILURE:
          return {
              ...state,
          message: action.message,
          editPaymentRuleStatus: false
          };
          case actionType.GET_PAYMENT_RULES_SUCCESS:
          return {
            ...state,
            getPaymentRulesDetails :action.payload,
            getPaymentRulesStatus: true,
            message: action.message
          };
          case actionType.GET_PAYMENT_RULES_FAILURE:
          return {
              ...state,
          message: action.message,
          getPaymentRulesStatus: false
          };
      case actionType.GET_EMPLOYE_LIST_SUCCESS:
        return {
          ...state,
          getEmployListDetails: action.payload,
          getEmployListStatus: true,
          message: action.message
        };
        case actionType.GET_EMPLOYE_LIST_FAILURE:
        return {
          ...state,
          message: action.message,
          getEmployListStatus: false,
          getEmployListDetails: {employeeList:[]},
        };
        case actionType.ADD_EMPLOYE_SUCCESS:
        return {
          ...state,
          addEmployStatus: true,
          message: action.message
          };
          case actionType.ADD_EMPLOYE_FAILURE:
          return {
              ...state,
          message: action.message,
          addEmployStatus: false
          };
          case actionType.EDIT_EMPLOYE_SUCCESS:
          return {
            ...state,
            editEmployeStatus: true,
            message: action.message
          };
          case actionType.EDIT_EMPLOYE_FAILURE:
          return {
              ...state,
          message: action.message,
          editEmployeStatus: false
          };
         case actionType.DELETE_EMPLOYE_SUCCESS:
         return {
           ...state,
           deleteEmployeStatus: true,
           message: action.message
          };
          case actionType.DELETE_EMPLOYE_FAILURE:
          return {
              ...state,
          message: action.message,
          deleteEmployeStatus: false
          };
          case actionType.GET_APPROXIMATE_COST_SUCCESS:
          return{
            ...state,
            getApproximateCostDetails: action.payload,
            getApproximateCostStatus: true
          } 
          case actionType.GET_APPROXIMATE_COST_FAILURE:
          return{
            ...state,
            getApproximateCostStatus: false,
          }
          case actionType.UPDATE_APPROXIMATE_COST_SUCCESS:
          return{
            ...state,
            updateApproximateCostDetails: action.payload,
            updateApproximateCostStatus:true
          }
          case actionType.UPDATE_APPROXIMATE_COST_FAILURE:
          return{
            ...state,
            updateApproximateCostStatus:false
          }

          case actionType.GET_BESTPERFORMANCE_SUCCESS:
          return{
            ...state,
            getBestPerformanceStatus:true,
            getBestPerformanceDetails: action.payload,
          }
          case actionType.GET_BESTPERFORMANCE_FAILURE:
          return{
            ...state,
            getBestPerformanceStatus:false
          }

          case actionType.GET_REQUEST_STATUS_LIST_SUCCESS:
          return{
            ...state,
            getRequestStatusListStatus:true,
            getRequestStatusListDetails: action.payload,
          }
          case actionType.GET_REQUEST_STATUS_LIST_FAILURE:
          return{
            ...state,
            getRequestStatusListStatus:false
          }
          case actionType.REVENUE_REPORT_SUCCESS:
          return{
            ...state,
            getRevenueReportStatus:true,
            getRevenueReportList:action.payload,
          }
          case actionType.REVENUE_REPORT_FAILURE:
          return{
            ...state,
            getRevenueReportStatus:false,
            getRevenueReportList:[],
          }


          case actionType.FAXEDPAGE_REPORT_SUCCESS:
          return{
            ...state,
            getFaxedReportStatus:true,
            getFaxedReportList:action.payload,
          }
          case actionType.FAXEDPAGE_REPORT_FAILURE:
          return{
            ...state,
            getFaxedReportStatus:false,
            getFaxedReportList:[],
          }
          case actionType.AVERAGE_REPORT_SUCCESS:
          return{
            ...state,
            getAverageReportStatus:true,
            getAverageReportList:action.payload,
          }
          case actionType.AVERAGE_REPORT_FAILURE:
          return{
            ...state,
            getAverageReportStatus:false,
            getAverageReportList:[],
          }
          case actionType.COMPLETED_REPORT_SUCCESS:
          return{
            ...state,
            getCompletedReportStatus:true,
            getCompletedReportList:action.payload,
          }
          case actionType.COMPLETED_REPORT_FAILURE:
          return{
            ...state,
            getCompletedReportStatus:false,
            getCompletedReportList:[],
          }
          case actionType.FACILITY_REPORT_SUCCESS:
          return{
            ...state,
            getFacilityReportStatus:true,
            getFacilityReportList:action.payload,
          }
          case actionType.FACILITY_REPORT_FAILURE:
          return{
            ...state,
            getFacilityReportStatus:false,
            getFacilityReportList:[],
          }
          case actionType.PRACTITIONER_REPORT_SUCCESS:
          return{
            ...state,
            getPractitionerReportStatus:true,
            getPractitionerReportList:action.payload,
          }
          case actionType.PRACTITIONER_REPORT_FAILURE:
          return{
            ...state,
            getPractitionerReportStatus:false,
            getPractitionerReportList:[],
          }
          case actionType.GET_HEDIS_FLAT_SUCCESS:
          return{
            ...state,
            getHedisFlatDetails: action.payload,
            getHedisFlatStatus: true
          } 
          case actionType.GET_HEDIS_FLAT_FAILURE:
          return{
            ...state,
            getHedisFlatStatus: false,
          }
          case actionType.UPDATE_HEDIS_FLAT_SUCCESS:
          return{
            ...state,
            updateHedisFlatDetails: action.payload,
            updateHedisFlatStatus:true
          }
          case actionType.UPDATE_HEDIS_FLAT_FAILURE:
          return{
            ...state,
            updateHedisFlatStatus:false
          }
          case actionType.DELETE_REQUESTED_PRACTICE_SUCCESS:
          return {
            ...state,
            deleteRequestedPracticeStatus: true,
            message: action.message
           };
           case actionType.DELETE_REQUESTED_PRACTICE_FAILURE:
           return {
               ...state,
           message: action.message,
           deleteRequestedPracticeStatus: false
           };


    default:
      return state;
  }
};
 export default adminReducer;